import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import BlogWidgets from './BlogWidgets';
import ContactUsWidgets from './ContactUsWidgets';
import CustomerFeedback from './CustomerFeedback';
import DeveloperProfile from './DeveloperProfile';
import Earnings from './Earnings';
import EmployeeStatus from './EmployeeStatus';
import GeneralCalendar from './GeneralCalendar';
import ManagerProfile from './ManagerProfile';
import ProductCart from './ProductCard';
import RecentActivity from './RecentActivity';
import Sales from './Sales';
import Sales1 from './Sales1';
import SocialWidgetCard from './SocialWidgetCard';
import UsageInBrowser from './UsageInBrowser';
import WeatherWidgets from './WeatherWidget';

const GeneralContain = () => {
  return (
    <>
      <Container fluid={true}>
        <Breadcrumbs justify='end' pageTitle='General' parent='Widgets' title='General' />
        <Row>
          <Earnings />
          <Sales />
          <Sales1 />
          <WeatherWidgets />
          <GeneralCalendar />
          <CustomerFeedback />
          <ManagerProfile />
          <RecentActivity />
          <DeveloperProfile />
          <UsageInBrowser />
          <SocialWidgetCard />
          <ProductCart />
          <EmployeeStatus />
          <BlogWidgets />
          <ContactUsWidgets />
        </Row>
      </Container>
    </>
  );
};

export default GeneralContain;
